import {isEmpty} from 'lodash'
import {createValidationForSchema} from '../../utils/ajvValidation'
import {validate as powtoonValidate} from '../../utils/powtoonValidation'
import schema from './schema/01.13.schema.json'
import {isDecimalInteger} from 'powtoon-commons/utils/numbers'
import {roundToSupportedPrecision} from 'powtoon-document/utils/duration'
import {getFirstSprite} from 'powtoon-document/utils/trackSpriteUtils'
import {isImageHolderItemWithContent, isSpriteWithAudioTracks} from 'powtoon-document'

let ajvValidate = null

export function initValidate ()  {
  if (!ajvValidate){
    ajvValidate = createValidationForSchema(schema)
  }
}

export const validate = async (powtoon,
  {
    strictMode = false,
    ignoreManifest = false,
    isValidTime = isDecimalInteger,
    getMinTimeStep,
    ignoreRichText = false
  } = {}) => {
  const powtoonValidationErrors = powtoonValidate(powtoon, {
    strictMode, ignoreManifest, isValidTime, getMinTimeStep, ignoreRichText
  })

  let powtoonForAjv = powtoon
  if (ignoreManifest) {
    powtoonForAjv = {...powtoon}
    delete(powtoonForAjv.manifest)
  }
  if (!ajvValidate){
    initValidate()
  }
  const ajvValidationErrors = ajvValidate (powtoonForAjv)

  if (!powtoonValidationErrors) {
    return ajvValidationErrors
  }

  if (!ajvValidationErrors) {
    return powtoonValidationErrors
  }

  return {
    errors: [...powtoonValidationErrors.errors, ...ajvValidationErrors.errors],
    // eslint-disable-next-line max-len
    errorMessage: `POWTOON VALIDATION:\n-------------------\n\n${powtoonValidationErrors.errorMessage}\n\nSCHEMA VALIDATION:\n------------------\n\n${ajvValidationErrors.errorMessage}`
  }
}

export function updatePowtoonContent(content) {
  // update powtoon content designed in a way to be executed only 1 or 0 time in every powtoon lifecycle
  // it powtoon content version is >= specific function version - this function will never run
  // here we should add missing fields to the powtoon document
  // later steps :
  // validate : we detect the missing asset in manifest , find wrong data and types
  // recovery : will try to fix all that is broken or missing including the manifest
  // part of the recovery will replace and update manifest using api call with all  manifest ids form server
  // this time we will :
  // * round track times to conform to our new frame time logic
  content.powtoon.masters?.tracks.back.forEach(masterTrack => {
    masterTrack.startTime = roundToSupportedPrecision(masterTrack.startTime)
    masterTrack.endTime = roundToSupportedPrecision(masterTrack.endTime)
  })

  content.powtoon.masters?.tracks.front.forEach(masterTrack => {
    masterTrack.startTime = roundToSupportedPrecision(masterTrack.startTime)
    masterTrack.endTime = roundToSupportedPrecision(masterTrack.endTime)
  })

  content.powtoon.audioTracks?.forEach(audioTrack => {
    if (audioTrack) {
      fixAudioTrackStartEndTimes(audioTrack)
    }
  })

  content.powtoon.slides.forEach(slide => {
    const {captions, camera, tracks, audioTracks} = slide

    tracks.forEach(track => {
      track.startTime = roundToSupportedPrecision(track.startTime)
      track.endTime = roundToSupportedPrecision(track.endTime)

      const sprite = getFirstSprite(track)
      fixSpriteStartEndTimes(sprite)

      if (isImageHolderItemWithContent(sprite)) {
        fixSpriteStartEndTimes(sprite.content)
      }
    })
    audioTracks?.forEach(audioTrack => {
      fixAudioTrackStartEndTimes(audioTrack)
    })
    if (!isEmpty(captions)) {
      for (const key in captions) {
        const captionsTracks = captions[key]
        if (isEmpty(captionsTracks)) {
          continue
        } else {
          captionsTracks.forEach(captionTrack => {
            if (captionTrack) {
              captionTrack.startTime = roundToSupportedPrecision(captionTrack.startTime)
              captionTrack.endTime = roundToSupportedPrecision(captionTrack.endTime)
            }
          })
        }
      }
    }
    
    if (!isEmpty(camera) && camera.animationGraphs?.keyframes) {
      camera.animationGraphs.keyframes.forEach(keyframe => {
        keyframe.time = roundToSupportedPrecision(keyframe.time)
      })
    }
  })
}

const fixAudioTrackStartEndTimes = (audioTrack) => {
  if (audioTrack.startTime !== undefined && audioTrack.endTime !== undefined) {
    audioTrack.startTime = roundToSupportedPrecision(audioTrack.startTime)
    audioTrack.endTime = roundToSupportedPrecision(audioTrack.endTime)
  }

  if (audioTrack.playbackSettings) {
    audioTrack.playbackSettings.startTime = roundToSupportedPrecision(audioTrack.playbackSettings.startTime)
    audioTrack.playbackSettings.endTime = roundToSupportedPrecision(audioTrack.playbackSettings.endTime)
  }
}

const fixSpriteStartEndTimes = (sprite) => {
  if (
    sprite?.playbackSettings &&
    sprite.playbackSettings.startTime !== undefined &&
    sprite.playbackSettings.endTime !== undefined
  ) {
    sprite.playbackSettings.startTime = roundToSupportedPrecision(sprite.playbackSettings.startTime)
    sprite.playbackSettings.endTime = roundToSupportedPrecision(sprite.playbackSettings.endTime)
  }

  if (isSpriteWithAudioTracks(sprite)) {
    sprite.audioTracks.forEach(audioTrack => {
      audioTrack.startTime = roundToSupportedPrecision(audioTrack.startTime)
      audioTrack.endTime = roundToSupportedPrecision(audioTrack.endTime)
    })
  }
}
